import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import useReveal from '@/hooks/useReveal';

export default function TermsPage() {
  useReveal();
  return (
    <div className="bg-ink-950 text-white">
      <Navbar />
      <section className="relative min-h-[50vh] flex items-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Ultra%20dark%20cinematic%20abstract%20digital%20contract%20document%20with%20purple%20neon%20glowing%20lines%20on%20deep%20black%20background%20premium%20technology%20legal%20visualization%20clean%20minimalist%20composition&width=1800&height=1200&seq=fc-terms-bg&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-ink-950/80 via-ink-950/70 to-ink-950" />
        <div className="relative mx-auto max-w-7xl px-6 pt-32 pb-16 w-full">
          <h1 className="font-display text-4xl md:text-6xl font-bold text-gradient">Terms & Conditions</h1>
          <p className="mt-4 text-white/60">Last updated: August 2026</p>
        </div>
      </section>
      <section className="relative py-20 px-6">
        <div className="mx-auto max-w-3xl space-y-10">
          {[{
            title: '1. Services',
            text: 'FormaCode Technologies provides technology services including but not limited to web development, AI automation, SEO, video editing, social media analytics, hosting, and advertising. Specific terms for each project will be outlined in a separate Statement of Work.',
          }, {
            title: '2. Project Timeline',
            text: 'Project timelines are estimates based on the scope defined in the proposal. Delays caused by client feedback, content delivery, or scope changes may extend timelines accordingly.',
          }, {
            title: '3. Payment Terms',
            text: 'Payment terms are specified in each project proposal. Typically, a deposit is required before work begins, with milestone-based payments thereafter. Final deliverables are released upon full payment.',
          }, {
            title: '4. Intellectual Property',
            text: 'Upon full payment, all custom work created for the client becomes the client property. FormaCode Technologies retains the right to display completed work in our portfolio unless otherwise agreed.',
          }, {
            title: '5. Revisions',
            text: 'Each project includes a defined number of revision rounds. Additional revisions beyond the agreed scope may incur extra charges.',
          }, {
            title: '6. Termination',
            text: 'Either party may terminate the agreement with 14 days written notice. Client is responsible for payment for all work completed up to the termination date.',
          }, {
            title: '7. Limitation of Liability',
            text: 'FormaCode Technologies liability is limited to the total amount paid by the client for the specific project. We are not liable for indirect, incidental, or consequential damages.',
          }, {
            title: '8. Governing Law',
            text: 'These terms are governed by the laws of the jurisdiction in which FormaCode Technologies is registered.',
          }].map((s) => (
            <div key={s.title} className="reveal">
              <h2 className="font-display text-xl font-bold text-white mb-3">{s.title}</h2>
              <p className="text-white/60 leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}